import { Controller } from '@hotwired/stimulus';
import { PaymentAccountsSearchMixin } from '../../../mixins/payment_accounts_search_mixin';

import AutoNumeric from 'autonumeric';
import { ClearPaymentAccountsMixin } from "../../../mixins/clear_payment_accounts_mixin";

export default class extends Controller {
  static targets = [
    'fspInput',
    'needyIdInput',
    'sourceAmountInput',
    'destinationAmountInput',
    'exchangeRate',
  ];

  static values = {
    fspPaymentAccountsFetchUrl: String,
    exchangeRatePrefix: String,
    turboFrameTagName: String,
    selectSelector: String,
  };

  initialize() {
    PaymentAccountsSearchMixin(this);
    ClearPaymentAccountsMixin(this);
    this.initialize_payment_accounts_search();
    this.calculate_exchange_rate();
  }

  fetch_fsp_payment_accounts() {
    if (this.fspInputTarget.checked) {
      this.needyIdInputTarget.disabled = true;
      this.needyIdInputTarget.value = null;

      this.turboGet(this.fspPaymentAccountsFetchUrlValue, {
        turbo_frame_table_id: this.turboFrameTagNameValue,
        select_id: document.querySelector(this.selectSelectorValue).id,
      });
    } else {
      this.clear_results();
      this.needyIdInputTarget.disabled = false;
    }
  }

  clear_results() {
    this.clear_payment_accounts(
      this.selectSelectorValue,
      this.turboFrameTagNameValue,
    );
  }

  calculate_exchange_rate() {
    const source_amount = this.parse_to_float(
      this.sourceAmountInputTarget.value,
    );
    const destination_amount = this.parse_to_float(
      this.destinationAmountInputTarget.value,
    );
    const calculation_possible = source_amount > 0 && destination_amount > 0;

    let exchange_rate_text = this.exchangeRatePrefixValue;

    if (calculation_possible) {
      const exchange_rate = AutoNumeric.format(
        source_amount / destination_amount,
        {
          decimalPlaces: 4,
          decimalCharacter: ',',
          digitGroupSeparator: ' ',
        },
      );

      exchange_rate_text += ` ${exchange_rate}`;
    }

    this.exchangeRateTarget.innerText = exchange_rate_text;
  }

  parse_to_float(value) {
    return parseFloat(value.replace(',', '.').replace(/[^\d.]/g, ''));
  }
}
